<template>
    <div>
        <Nav></Nav>
        <b-container>
            <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
            <TipsAlert :tipswords="masterTips.tipswords"
                       :status="masterTips.status"
                       :videostatus="masterTips.videostatus"
                       :videosrc="masterTips.videosrc">

            </TipsAlert>
            <FormPhone ref="modal" v-on:sendAction="GoPhoneFree"></FormPhone>
            <b-button pill block variant="primary" size="lg" class="text-white shadow-lg my-3" style=" background: linear-gradient(180deg, rgba(215,176,128,1) 0%, rgba(164,120,85,1) 100%)" @click="callaction">取得號碼分析</b-button>
        </b-container>
        <AnaLoading way="Normal" :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import TipsAlert from '@/components/TipsAlert.vue'
import FormPhone from '@/components/FormPhone.vue'
import AnaLoading from '@/components/AnaLoading.vue'

export default {
  name: 'Phone',
  components: {Nav,PageHeader,TipsAlert,FormPhone,AnaLoading},
  data () {
    return {
      productName:'電話分析',
      formData: {
        phone:''
      },
      pageloading:false,
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'https://www.youtube.com/watch?v=a9nz1Ml5N1g',
        tipswords:'（電話分析）數字都隱含著神秘意義，透過『數字靈動』分析，得知自己的電話號碼，是幫自己加分或扣分，只需要輸入自己的完整號碼，馬上就能夠幫您評分出結果。',
      },
    }
  },
  methods: {
    callaction () {
      this.$refs.modal.toggleModal()
    },
    GoPhoneFree (data) {
      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        phone: data,
        producttype:'PhoneFree'
      }).then((res) => {
        setTimeout(()=>{
          this.pageloading = false
          this.$router.push('/PhoneResult');
        },1500)
      }).catch((res) => {
        this.pageloading = false
      });
    }

  }
}
</script>

<style scoped>

</style>
